import { useEffect, useState } from 'react';
import { onboardingService } from '../../queries/onboarding';
import useUserMemory from '../use-user-memory';

const useCheckOnboarding = () => {
  const { memoryUserUuid } = useUserMemory();

  const userUuid = memoryUserUuid;

  const [isFinishedOnboarding, setIsFinishedOnboarding] = useState(false);

  const checkOnboarding = async () => {
    if (!userUuid) return;
    const response = await onboardingService.check(userUuid);
    setIsFinishedOnboarding(response.finishedOnboarding);
  };
  useEffect(() => {
    checkOnboarding();
  }, [userUuid]);

  return { isFinishedOnboarding };
};

const useFinishOnboarding = () => {
  const { memoryUserUuid } = useUserMemory();

  const userUuid = memoryUserUuid;

  const [isLoadingFinishOnboarding, setIsLoadingFinishOnboarding] =
    useState(true);
  const [isFinishedOnboarding, setIsFinishedOnboarding] = useState(false);

  const finishOnboarding = async () => {
    if (!userUuid) return;
    const response = await onboardingService.finish({ userUuid });
    setIsFinishedOnboarding(response.finishedOnboarding);
  };

  const checkIsFinishedOnboarding = async () => {
    if (!userUuid) return;
    setIsLoadingFinishOnboarding(true);
    const response = await onboardingService.check(userUuid);
    setIsFinishedOnboarding(response.finishedOnboarding);
    setIsLoadingFinishOnboarding(false);
  };

  useEffect(() => {
    checkIsFinishedOnboarding();
  }, [userUuid]);

  return { isFinishedOnboarding, finishOnboarding, isLoadingFinishOnboarding };
};

const useDismissOnboarding = () => {
  const { memoryUserUuid } = useUserMemory();
  const [isShouldShowOnboarding, setIsShouldShowOnboarding] = useState(false);

  const userUuid = memoryUserUuid;

  const toggleShouldShowOnboarding = async (shouldShow: boolean) => {
    if (!userUuid) return;
    await onboardingService.toogle({ userUuid, shouldShow });
    setIsShouldShowOnboarding(shouldShow);
  };

  const checkShouldShowOnboarding = async () => {
    if (!userUuid) return;
    const response = await onboardingService.check(userUuid);
    setIsShouldShowOnboarding(!response.dontShowOnboardingAgain);
  };

  useEffect(() => {
    checkShouldShowOnboarding();
  }, [userUuid]);

  return {
    isShouldShowOnboarding,
    checkShouldShowOnboarding,
    toggleShouldShowOnboarding,
  };
};

export { useCheckOnboarding, useFinishOnboarding, useDismissOnboarding };
